<template>
	<div v-if="loaded">
		<router-view />
	</div>
	<div id="wave_animation_wrapper" v-if="$store.state.isLoading">
		<div class="logo"></div>
		<!-- <div id="wave_animation">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div> -->
	</div>
</template>

<style lang="scss"></style>

<script>
export default {
	data() {
		return {
			words: [],
			loaded: false,
		};
	},
	mounted() {
		if (location.host.slice(0, 2) == "en") {
			console.log("en");
			window.api_url = "https://en.bestphonekosher.com/api_vue/";
		} else {
			console.log("he");
			window.api_url = "https://bestphonekosher.com/api_vue/";
		}
		const two_hours = 1000 * 60 * 60 * 2;
		const cookie_timer = Date.now() - two_hours;

		if (cookie_timer > localStorage.getItem("user_token_date")) {
			localStorage.removeItem("user_token");
			localStorage.removeItem("user_token_date");
		}

		this.$store.commit("setIsLoading", { isLoading: true });

		this.api({ action: "general", method: "get" }, (data) => {
			localStorage.setItem("user_token", data.data.cookie);
			localStorage.setItem("user_token_date", Date.now());
			const { words } = data.data;
			this.$store.commit("setWords", { words });
			this.$store.commit("setIsLoading", { isLoading: false });
			this.loaded = true;
		});
	},
};
</script>

